
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';

// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const Cancelled = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeStatus, setActiveStatus] = useState('Submitted');
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [currentApiEndpoint, setCurrentApiEndpoint] = useState('');
//   const [message, setMessage] = useState('');

//   const user_id = localStorage.getItem('user_id');

//   useEffect(() => {
//     fetchParticipants();
//   }, [activeToggle, activeStatus]);

//   const fetchParticipants = async () => {
//     try {
//       const endpoint =
//         activeToggle === 'Single'
//           ? 'https://newbackend.elephant-tank.com/api/get_idea_submission/'
//           : 'https://newbackend.elephant-tank.com/api/get_idea_submission/';
  
//       const response = await axios.get(endpoint);
  
//       const fetchedData = response.data
//         .filter(
//           (item) =>
//             item.status && item.status.toLowerCase() === activeStatus.toLowerCase()
//         )
//         .map((item) => ({
//           id: item.id,
//           title: item.title,
//           description: item.description,
//           projectType: item.project_type || 'N/A',
//           aiScore: item.ai_score || 'N/A',
//           submissionDate: item.created_at,
//           approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
//           isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
//           studentId: item.stud_id,
//           numberOfMembers: item.number_of_member || null,
//           groupName: item.name_of_group || 'N/A',
//         }));
  
//       setData(fetchedData);
//     } catch (error) {
//       console.error('Error fetching participants:', error);
//     }
//   };
  
  
  

//   const openMessageDialog = (ideaId, apiEndpoint) => {
//     setCurrentIdeaId(ideaId);
//     setCurrentApiEndpoint(apiEndpoint);
//     setOpenDialog(true);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage('');
//   };

//   const handleSubmitMessage = async () => {
//     if (!message) {
//       alert('Message is required');
//       return;
//     }

//     const payload = {
//       investor_id: user_id,
//       idea_id: 7,
//       message: message,
//     };

//     try {
//       await axios.post(currentApiEndpoint, payload);
//       setOpenDialog(false);
//       setMessage('');
//       fetchParticipants();
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const filteredData = data.filter((row) =>
//     (row.projectTitle || '').toLowerCase().includes(searchTerm)
//   );
  

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#000',mt:8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>Projects Status</Typography>}
//           subheader="Manage Group and Single Projects"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff',mt:8 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Group
//               </Button>
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>

//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//               }}
//               sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//             />
//           </Box>

//           <Box sx={{ mt: 2 }}>
//             {['Submitted', 'Interested', 'Funded'].map((status) => (
//               <Button
//                 key={status}
//                 variant={activeStatus === status ? 'contained' : 'outlined'}
//                 onClick={() => setActiveStatus(status)}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeStatus === status ? '#1EA0D833' : 'transparent',
//                   color: activeStatus === status ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 {status}
//               </Button>
//             ))}
//           </Box>
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 {activeToggle === 'Group' && <StyledTableCell sx={{ color: '#000' }}>Members</StyledTableCell>}
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Uploaded File</StyledTableCell>
//                 {activeStatus !== 'Funded' && <StyledTableCell sx={{ color: '#000' }}>Action</StyledTableCell>}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#FCE4EC' } }}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.name}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
//                   <StyledTableCell>{row.projectTitle}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.ideaFile ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.ideaFile}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   {activeStatus === 'Submitted' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="contained"
//                         size="small"
//                         sx={{ backgroundColor: '#6F42C1', color: '#fff', '&:hover': { backgroundColor: '#5E35B1' } }}
//                         onClick={() =>
//                           openMessageDialog(row.ideaId, 'https://newbackend.elephant-tank.com/api/show_interest/')
//                         }
//                       >
//                         Mark as Interested
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                   {activeStatus === 'Interested' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="contained"
//                         size="small"
//                         sx={{ backgroundColor: '#6F42C1', color: '#fff', '&:hover': { backgroundColor: '#5E35B1' } }}
//                         onClick={() =>
//                           openMessageDialog(row.ideaId, 'https://newbackend.elephant-tank.com/api/fund_project/')
//                         }
//                       >
//                         Mark as Funded
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {filteredData.length > ITEMS_PER_PAGE && (
//           <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
//             <Pagination
//               count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//               page={page}
//               onChange={handleChangePage}
//               shape="rounded"
//               sx={{ '.MuiPaginationItem-root': { color: '#673AB7' } }}
//             />
//           </Box>
//         )}
//       </Card>

//       <Dialog open={openDialog} onClose={handleDialogClose}>
//         <DialogTitle>Send a Message</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Enter your message for this action:</DialogContentText>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Message"
//             fullWidth
//             variant="outlined"
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={handleSubmitMessage} variant="contained">
//             Submit
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Cancelled;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';

// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const Cancelled = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeStatus, setActiveStatus] = useState('Submitted');
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [currentApiEndpoint, setCurrentApiEndpoint] = useState('');
//   const [message, setMessage] = useState('');

//   const user_id = localStorage.getItem('user_id');

//   useEffect(() => {
//     fetchParticipants();
//   }, [activeToggle, activeStatus]);

//   const fetchParticipants = async () => {
//     try {
//       const endpoint =
//         activeToggle === 'Single'
//           ? 'https://newbackend.elephant-tank.com/api/get_idea_submission/'
//           : 'https://newbackend.elephant-tank.com/api/get_idea_submission/';
  
//       const response = await axios.get(endpoint);
  
//       const fetchedData = response.data
//         .filter(
//           (item) =>
//             item.status && item.status.toLowerCase() === activeStatus.toLowerCase()
//         )
//         .map((item) => ({
//           id: item.id,
//           title: item.title,
//           description: item.description,
//           projectType: item.project_type || 'N/A',
//           aiScore: item.ai_score || 'N/A',
//           submissionDate: item.created_at,
//           approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
//           isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
//           studentId: item.stud_id,
//           numberOfMembers: item.number_of_member || null,
//           groupName: item.name_of_group || 'N/A',
//         }));
  
//       setData(fetchedData);
//     } catch (error) {
//       console.error('Error fetching participants:', error);
//     }
//   };

//   const openMessageDialog = (ideaId, apiEndpoint) => {
//     setCurrentIdeaId(ideaId);
//     setCurrentApiEndpoint(apiEndpoint);
//     setOpenDialog(true);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage('');
//   };

//   const handleSubmitMessage = async () => {
//     if (!message) {
//       alert('Message is required');
//       return;
//     }

//     const payload = {
//       investor_id: user_id,
//       idea_id: currentIdeaId,
//       message: message,
//     };

//     try {
//       await axios.post(currentApiEndpoint, payload);
//       setOpenDialog(false);
//       setMessage('');
//       fetchParticipants();
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     (row.title || '').toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#000', mt: 8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>Projects Status</Typography>}
//           subheader="Manage Group and Single Projects"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', mt: 8 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Group
//               </Button>
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>

//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//               }}
//               sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//             />
//           </Box>

//           <Box sx={{ mt: 2 }}>
//             {['Submitted', 'Interested', 'Funded'].map((status) => (
//               <Button
//                 key={status}
//                 variant={activeStatus === status ? 'contained' : 'outlined'}
//                 onClick={() => setActiveStatus(status)}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeStatus === status ? '#1EA0D833' : 'transparent',
//                   color: activeStatus === status ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 {status}
//               </Button>
//             ))}
//           </Box>
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 {activeToggle === 'Group' && <StyledTableCell sx={{ color: '#000' }}>Members</StyledTableCell>}
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Uploaded File</StyledTableCell>
//                 {activeStatus !== 'Funded' && <StyledTableCell sx={{ color: '#000' }}>Action</StyledTableCell>}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#FCE4EC' } }}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.name}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.ideaFile ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.ideaFile}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   {activeStatus === 'Submitted' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => openMessageDialog(row.id, '/api/investor/idea_submitted/')}
//                       >
//                         Mark as Interested
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                   {activeStatus === 'Interested' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => openMessageDialog(row.id, '/api/investor/idea_interested/')}
//                       >
//                         Mark as Funded
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>

//       <Dialog open={openDialog} onClose={handleDialogClose}>
//         <DialogTitle>Send Message</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Enter your message:</DialogContentText>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             sx={{ mt: 1 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={handleSubmitMessage}>Submit</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Cancelled;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';
// import swal from 'sweetalert';


// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const Cancelled = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeStatus, setActiveStatus] = useState('Submitted');
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [currentApiEndpoint, setCurrentApiEndpoint] = useState('');
//   const [message, setMessage] = useState('');

//   const user_id = localStorage.getItem('user_id');

//   useEffect(() => {
//     fetchParticipants();
//   }, [activeToggle, activeStatus]);

//   const fetchParticipants = async () => {
//     try {
//       const endpoint =
//         activeToggle === 'Single'
//           ? 'https://newbackend.elephant-tank.com/api/get_idea_submission/'
//           : 'https://newbackend.elephant-tank.com/api/get_idea_submission/';
  
//       const response = await axios.get(endpoint);
  
//       const fetchedData = response.data
//         .filter(
//           (item) =>
//             item.status && item.status.toLowerCase() === activeStatus.toLowerCase() &&
//             item.admin_approval === true // Only show admin approved projects
//         )
//         .map((item) => ({
//           id: item.id,
//           title: item.title,
//           description: item.description,
//           projectType: item.project_type || 'N/A',
//           aiScore: item.ai_score || 'N/A',
//           submissionDate: item.created_at,
//           approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
//           isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
//           studentId: item.stud_id,
//           numberOfMembers: item.number_of_member || null,
//           groupName: item.name_of_group || 'N/A',
//         }));
  
//       setData(fetchedData);
//     } catch (error) {
//       console.error('Error fetching participants:', error);
//     }
//   };

//   const openMessageDialog = (ideaId, apiEndpoint) => {
//     setCurrentIdeaId(ideaId);
//     setCurrentApiEndpoint(apiEndpoint);
//     setOpenDialog(true);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage('');
//   };

//   const handleSubmitMessage = async () => {
//     if (!message) {
//       alert('Message is required');
//       return;
//     }
  
//     const payload = {
//       investor_id: user_id,
//       idea_id: currentIdeaId,
//       message: message,
//     };
  
//     try {
//       const response = await axios.post(currentApiEndpoint, payload);
//       if (response.data && response.data.msg) {
//         swal("Success", response.data.msg, "success");
//       }
//       setOpenDialog(false);
//       setMessage('');
//       fetchParticipants();
//     } catch (error) {
//       console.error('Error updating status:', error);
//     }
//   };
  
//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     (row.title || '').toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#000', mt: 8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>Projects Status</Typography>}
//           subheader="Manage Group and Single Projects"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', mt: 8 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Group
//               </Button>
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>

//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//               }}
//               sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//             />
//           </Box>

//           <Box sx={{ mt: 2 }}>
//             {['Submitted', 'Interested', 'Funded'].map((status) => (
//               <Button
//                 key={status}
//                 variant={activeStatus === status ? 'contained' : 'outlined'}
//                 onClick={() => setActiveStatus(status)}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeStatus === status ? '#1EA0D833' : 'transparent',
//                   color: activeStatus === status ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 {status}
//               </Button>
//             ))}
//           </Box>
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>{activeToggle === 'Group' ? 'Group Name' : 'Name'}</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 {activeToggle === 'Group' && <StyledTableCell sx={{ color: '#000' }}>Members</StyledTableCell>}
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Uploaded File</StyledTableCell>
//                 {activeStatus !== 'Funded' && <StyledTableCell sx={{ color: '#000' }}>Action</StyledTableCell>}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id} sx={{ '&:hover': { backgroundColor: '#FCE4EC' } }}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.name}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   {activeToggle === 'Group' && <StyledTableCell>{row.numberOfMembers}</StyledTableCell>}
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.ideaFile ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.ideaFile}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   {activeStatus === 'Submitted' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => openMessageDialog(row.id, 'https://newbackend.elephant-tank.com/api/show_interest/')}
//                       >
//                         Mark as Interested
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                   {activeStatus === 'Interested' && (
//                     <StyledTableCell>
//                       <Button
//                         variant="outlined"
//                         color="secondary"
//                         onClick={() => openMessageDialog(row.id, 'https://newbackend.elephant-tank.com/api/fund_project/')}
//                       >
//                         Mark as Funded
//                       </Button>
//                     </StyledTableCell>
//                   )}
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>

//       <Dialog open={openDialog} onClose={handleDialogClose}>
//         <DialogTitle>Send Message</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Enter your message:</DialogContentText>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             sx={{ mt: 1 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={handleSubmitMessage}>Submit</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Cancelled;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   IconButton,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';
// import swal from 'sweetalert';

// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });

// const ITEMS_PER_PAGE = 5;

// const Cancelled = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeStatus, setActiveStatus] = useState('Submitted');
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [message, setMessage] = useState('');
//   const [amountRange, setAmountRange] = useState('');

//   const user_id = localStorage.getItem('user_id');

//   useEffect(() => {
//     fetchParticipants();
//   }, [activeToggle, activeStatus]);

//   const fetchParticipants = async () => {
//     try {
//       const endpoint = 'https://newbackend.elephant-tank.com/api/get_idea_submission/';

//       const response = await axios.get(endpoint);
//       const fetchedData = response.data
//         .filter(
//           (item) =>
//             item.status &&
//             item.status.toLowerCase() === activeStatus.toLowerCase() &&
//             item.admin_approval === true
//         )
//         .map((item) => ({
//           id: item.id,
//           title: item.title,
//           description: item.description,
//           projectType: item.project_type || 'N/A',
//           aiScore: item.ai_score || 'N/A',
//           submissionDate: item.created_at,
//           approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
//           isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
//           studentId: item.stud_id,
//           numberOfMembers: item.number_of_member || null,
//           groupName: item.name_of_group || 'N/A',
//           idea: item.idea || null,
//           ppt: item.ppt || null,
//           video_file: item.video_file || null,
//         }));

//       setData(fetchedData);
//     } catch (error) {
//       console.error('Error fetching participants:', error);
//     }
//   };

//   const openMessageDialog = (ideaId) => {
//     setCurrentIdeaId(ideaId);
//     setOpenDialog(true);
//   };

//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage('');
//     setAmountRange('');
//   };

//   const handleSubmitMessage = async () => {
//     if (!message || !amountRange) {
//       alert('Message and amount range are required');
//       return;
//     }

//     const payload = {
//       investor_id: user_id,
//       idea_id: currentIdeaId,
//       message: message,
//       amount_range: amountRange,
//     };

//     try {
//       const response = await axios.post('https://newbackend.elephant-tank.com/api/show_interest/', payload);
//       if (response.data && response.data.msg) {
//         swal('Success', response.data.msg, 'success');
//       }
//       setOpenDialog(false);
//       setMessage('');
//       setAmountRange('');
//       fetchParticipants();
//     } catch (error) {
//       console.error('Error submitting message:', error);
//       swal('Error', 'You have already shown interest in this project', 'error');
//     }
//   };

//   const handleChangePage = (event, newPage) => setPage(newPage);

//   const filteredData = data.filter((row) =>
//     (row.title || '').toLowerCase().includes(searchTerm)
//   );

//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #D6F8F8, #E9D8FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', color: '#000', mt: 8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000' }}>Projects Status</Typography>}
//           subheader="Manage Group and Single Projects"
//           sx={{ py: 2, borderBottom: '1px solid #fff' }}
//         />
//       </Card>

//       <Card elevation={2} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#fff', mt: 8 }}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               {/* <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Group
//               </Button> */}
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#1EA0D833' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>

//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#673AB7' }} />,
//               }}
//               sx={{ width: '300px', borderColor: '#1EA0D833', backgroundColor: '#F8F9FA', borderRadius: 2 }}
//             />
//           </Box>

//           <Box sx={{ mt: 2 }}>
//             {['Submitted'].map((status) => (
//               <Button
//                 key={status}
//                 variant={activeStatus === status ? 'contained' : 'outlined'}
//                 onClick={() => setActiveStatus(status)}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeStatus === status ? '#1EA0D833' : 'transparent',
//                   color: activeStatus === status ? '#fff' : '#673AB7',
//                   '&:hover': { backgroundColor: '#FF8DA8' },
//                 }}
//               >
//                 {status}
//               </Button>
//             ))}
//           </Box>
//         </CardContent>
//       </Card>

//       <Card elevation={3} sx={{ borderRadius: 4, backgroundColor: '#FDF8FF' }}>
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#1EA0D833' }}>
//                 <StyledTableCell sx={{ color: '#000' }}>Sr. No.</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Title</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Type</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Project Pdf</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>PPT</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Video File</StyledTableCell>
//                 <StyledTableCell sx={{ color: '#000' }}>Action</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow
//                   key={row.id}
//                   sx={{
//                     '&:hover': { backgroundColor: '#FCE4EC', cursor: 'pointer' },
//                   }}
//                   onClick={() => {
//                     if (row.idea) {
//                       window.open(row.idea, '_blank', 'noopener,noreferrer');
//                     } else {
//                       alert('No link available for this project.');
//                     }
//                   }}
//                 >
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.idea ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.idea}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     {row.ppt ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.ppt}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     {row.video_file ? (
//                       <IconButton
//                         size="small"
//                         href={`${row.video_file}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <CloudDownloadIcon sx={{ color: '#1EA0D833' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     <Button
//                       variant="outlined"
//                       color="secondary"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         openMessageDialog(row.id);
//                       }}
//                     >
//                       Show Interest
//                     </Button>
//                   </StyledTableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>

//       <Dialog open={openDialog} onClose={handleDialogClose}>
//         <DialogTitle>Send Message</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Enter your message and amount range:</DialogContentText>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             placeholder="Message"
//             sx={{ mt: 1 }}
//           />
//           <TextField
//             fullWidth
//             value={amountRange}
//             onChange={(e) => setAmountRange(e.target.value)}
//             placeholder="Amount Range"
//             sx={{ mt: 2 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={handleSubmitMessage}>Submit</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default Cancelled;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Pagination,
//   TextField,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Card,
//   CardContent,
//   CardHeader,
//   IconButton,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// import GroupIcon from '@mui/icons-material/Group';
// import PersonIcon from '@mui/icons-material/Person';
// import SearchIcon from '@mui/icons-material/Search';
// import axios from 'axios';
// import swal from 'sweetalert';
 
// const StyledTableCell = styled(TableCell)({
//   padding: '16px',
//   fontSize: '0.875rem',
//   color: '#4A4A4A',
// });
 
// const ITEMS_PER_PAGE = 5;
 
// const Cancelled = () => {
//   const [activeToggle, setActiveToggle] = useState('Group');
//   const [page, setPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [activeStatus, setActiveStatus] = useState('Submitted');
//   const [data, setData] = useState([]);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [currentIdeaId, setCurrentIdeaId] = useState(null);
//   const [message, setMessage] = useState('');
//   const [amountRange, setAmountRange] = useState('');
//   const [categoryFilter, setCategoryFilter] = useState('');
 
//   const user_id = localStorage.getItem('user_id');
 
//   useEffect(() => {
//     fetchParticipants();
//   }, [activeToggle, activeStatus]);
 
//   const fetchParticipants = async () => {
//     try {
//       swal({
//         title: 'Loading...',
//         text: 'Fetching uninterested projects, please wait.',
//         icon: 'info',
//         buttons: false,
//         closeOnClickOutside: false,
//       });
 
//       const endpoint = `https://newbackend.elephant-tank.com/api/uninterested_projects/${user_id}/`;
//       const response = await axios.get(endpoint);
 
//       const fetchedData = response.data
//         .filter((item) =>
//           activeToggle === 'Group'
//             ? !item.is_single_sub
//             : item.is_single_sub
//         )
//         .map((item) => ({
//           id: item.id,
//           title: item.title,
//           description: item.description,
//           projectType: item.project_type || 'N/A',
//           aiScore: item.ai_score || 'N/A',
//           submissionDate: item.created_at,
//           approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
//           isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
//           studentId: item.stud_id,
//           numberOfMembers: item.number_of_member || null,
//           groupName: item.name_of_group || 'N/A',
//           idea: item.idea || null,
//           ppt: item.ppt || null,
//           video_file: item.video_file || null,
//         }));
 
//       swal.close();
//       setData(fetchedData);
//     } catch (error) {
//       swal('Error', 'Failed to fetch uninterested projects. Please try again later.', 'error');
//       console.error('Error fetching participants:', error);
//     }
//   };
 
//   const openMessageDialog = (ideaId) => {
//     setCurrentIdeaId(ideaId);
//     setOpenDialog(true);
//   };
 
//   const handleDialogClose = () => {
//     setOpenDialog(false);
//     setMessage('');
//     setAmountRange('');
//   };
 
//   const handleSubmitMessage = async () => {
//     if (!message || !amountRange) {
//       swal('Error', 'Message and amount range are required.', 'error');
//       return;
//     }
 
//     const payload = {
//       investor_id: user_id,
//       idea_id: currentIdeaId,
//       message: message,
//       amount_range: amountRange,
//     };
 
//     try {
//       swal({
//         title: 'Submitting...',
//         text: 'Please wait while we submit your message.',
//         icon: 'info',
//         buttons: false,
//         closeOnClickOutside: false,
//       });
 
//       const response = await axios.post('https://newbackend.elephant-tank.com/api/show_interest/', payload);
 
//       if (response.data && response.data.msg) {
//         swal('Success', response.data.msg, 'success');
//       }
 
//       setOpenDialog(false);
//       setMessage('');
//       setAmountRange('');
//       fetchParticipants();
//     } catch (error) {
//       swal('Error', 'You have already shown interest in this project.', 'error');
//       console.error('Error submitting message:', error);
//     }
//   };
 
//   const handleChangePage = (event, newPage) => setPage(newPage);
 
//   const filteredData = data
//     .filter((row) =>
//       (row.title || '').toLowerCase().includes(searchTerm)
//     )
//     .filter((row) =>
//       categoryFilter ? row.projectType === categoryFilter : true
//     );
 
//   const paginatedData = filteredData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );
 
//   return (
//     <Box sx={{ p: 4, background: 'linear-gradient(135deg, #E8F5E9, #E3F2FD)', minHeight: '100vh' }}>
//       <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#FAFAFA', color: '#000', mt: 8 }}>
//         <CardHeader
//           title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2C3E50' }}>Submitted Projects</Typography>}
//           subheader="View projects are Submitted by Entrepreneur"
//           sx={{ py: 2, borderBottom: '1px solid #E0E0E0' }}
//         />
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Box>
//               <Button
//                 variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Group')}
//                 startIcon={<GroupIcon />}
//                 sx={{
//                   mr: 1,
//                   backgroundColor: activeToggle === 'Group' ? '#424242' : 'transparent',
//                   color: activeToggle === 'Group' ? '#fff' : '#2C3E50',
//                   '&:hover': { backgroundColor: '#616161' },
//                 }}
//               >
//                 Group
//               </Button>
//               <Button
//                 variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
//                 onClick={() => setActiveToggle('Single')}
//                 startIcon={<PersonIcon />}
//                 sx={{
//                   backgroundColor: activeToggle === 'Single' ? '#424242' : 'transparent',
//                   color: activeToggle === 'Single' ? '#fff' : '#2C3E50',
//                   '&:hover': { backgroundColor: '#616161' },
//                 }}
//               >
//                 Single
//               </Button>
//             </Box>
 
//             <TextField
//               placeholder="Search by Project Title"
//               size="small"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
//               InputProps={{
//                 startAdornment: <SearchIcon sx={{ mr: 1, color: '#2C3E50' }} />,
//               }}
//               sx={{ width: '300px', backgroundColor: '#F5F5F5', borderRadius: 2, mr: 2 }}
//             />
 
//             <FormControl size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Category</InputLabel>
//               <Select
//                 value={categoryFilter}
//                 onChange={(e) => setCategoryFilter(e.target.value)}
//               >
//                 <MenuItem value="">All Categories</MenuItem>
//                 <MenuItem value="AI/ML">AI/ML</MenuItem>
//                 <MenuItem value="Technology">Technology</MenuItem>
//                 <MenuItem value="Real Estate">Real Estate</MenuItem>
//                 <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
//                 <MenuItem value="Pharmacy ">Pharmacy </MenuItem>
//                 <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
//                 <MenuItem value="Education">Education</MenuItem>
//                 <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
//                 <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
//                 <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
//                 <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
//                 <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
//                 <MenuItem value="Others">Others</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </CardContent>
 
//         <TableContainer>
//           <Table>
//             <TableHead>
//               <TableRow sx={{ backgroundColor: '#B0BEC5' }}>
//                 <StyledTableCell>Sr. No.</StyledTableCell>
//                 <StyledTableCell>Project Title</StyledTableCell>
//                 <StyledTableCell>Project Type</StyledTableCell>
//                 <StyledTableCell>Project Pdf</StyledTableCell>
//                 <StyledTableCell>PPT</StyledTableCell>
//                 <StyledTableCell>Video File</StyledTableCell>
//                 <StyledTableCell>Action</StyledTableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {paginatedData.map((row, index) => (
//                 <TableRow key={row.id}>
//                   <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
//                   <StyledTableCell>{row.title}</StyledTableCell>
//                   <StyledTableCell>{row.projectType}</StyledTableCell>
//                   <StyledTableCell>
//                     {row.idea ? (
//                       <IconButton
//                         size="small"
//                         href={row.idea}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#424242' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     {row.ppt ? (
//                       <IconButton
//                         size="small"
//                         href={row.ppt}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#424242' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     {row.video_file ? (
//                       <IconButton
//                         size="small"
//                         href={row.video_file}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <CloudDownloadIcon sx={{ color: '#424242' }} />
//                       </IconButton>
//                     ) : (
//                       'No file'
//                     )}
//                   </StyledTableCell>
//                   <StyledTableCell>
//                     <Button
//                       variant="contained"
//                       sx={{
//                         backgroundColor: '#424242',
//                         color: '#fff',
//                         '&:hover': { backgroundColor: '#616161' },
//                       }}
//                       onClick={() => openMessageDialog(row.id)}
//                     >
//                       Show Interest
//                     </Button>
//                   </StyledTableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
 
//         <Pagination
//           count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
//           page={page}
//           onChange={handleChangePage}
//           sx={{ mt: 3 }}
//         />
//       </Card>
 
//       <Dialog open={openDialog} onClose={handleDialogClose}>
//         <DialogTitle>Send Message</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Enter your message and amount range:</DialogContentText>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             value={message}
//             onChange={(e) => setMessage(e.target.value)}
//             placeholder="Message"
//             sx={{ mt: 1 }}
//           />
//           <TextField
//             fullWidth
//             value={amountRange}
//             onChange={(e) => setAmountRange(e.target.value)}
//             placeholder="Amount Range"
//             sx={{ mt: 2 }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDialogClose}>Cancel</Button>
//           <Button onClick={handleSubmitMessage}>Submit</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };
 
// export default Cancelled;
import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import swal from 'sweetalert';

const StyledTableCell = styled(TableCell)({
  padding: '16px',
  fontSize: '0.875rem',
  color: '#4A4A4A',
});

const ITEMS_PER_PAGE = 5;

const Cancelled = () => {
  const [activeToggle, setActiveToggle] = useState('Group');
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeStatus, setActiveStatus] = useState('Submitted');
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentIdeaId, setCurrentIdeaId] = useState(null);
  const [message, setMessage] = useState('');
  const [amountRange, setAmountRange] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');

  const user_id = localStorage.getItem('user_id');

  useEffect(() => {
    fetchParticipants();
  }, [activeToggle, activeStatus]);

  const fetchParticipants = async () => {
    try {
      swal({
        title: 'Loading...',
        text: 'Fetching uninterested projects, please wait.',
        icon: 'info',
        buttons: false,
        closeOnClickOutside: false,
      });
  
      const endpoint = `https://newbackend.elephant-tank.com/api/uninterested_projects/${user_id}/`;
      const response = await axios.get(endpoint);
  
      const fetchedData = response.data
        .filter((item) => 
          item.admin_approval === true && 
          (activeToggle === 'Group' ? !item.is_single_sub : item.is_single_sub)
        )
        .map((item) => ({
          id: item.id,
          title: item.title,
          description: item.description,
          projectType: item.project_type || 'N/A',
          aiScore: item.ai_score || 'N/A',
          submissionDate: item.created_at,
          approvalStatus: item.admin_approval ? 'Approved' : 'Pending',
          isSingleSubmission: item.is_single_sub ? 'Yes' : 'No',
          studentId: item.stud_id,
          numberOfMembers: item.number_of_member || null,
          groupName: item.name_of_group || 'N/A',
          idea: item.idea || null,
          ppt: item.ppt || null,
          video_file: item.video_file || null,
        }));
  
      swal.close();
      setData(fetchedData);
    } catch (error) {
      swal('Error', 'Failed to fetch uninterested projects. Please try again later.', 'error');
      console.error('Error fetching participants:', error);
    }
  };
  
  const openMessageDialog = (ideaId) => {
    setCurrentIdeaId(ideaId);
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setMessage('');
    setAmountRange('');
  };

  const handleSubmitMessage = async () => {
    if (!message || !amountRange) {
      swal('Error', 'Message and amount range are required.', 'error');
      return;
    }

    const payload = {
      investor_id: user_id,
      idea_id: currentIdeaId,
      message: message,
      amount_range: amountRange,
    };

    try {
      swal({
        title: 'Submitting...',
        text: 'Please wait while we submit your message.',
        icon: 'info',
        buttons: false,
        closeOnClickOutside: false,
      });

      const response = await axios.post('https://newbackend.elephant-tank.com/api/show_interest/', payload);

      if (response.data && response.data.msg) {
        swal('Success', response.data.msg, 'success');
      }

      setOpenDialog(false);
      setMessage('');
      setAmountRange('');
      fetchParticipants();
    } catch (error) {
      swal('Error', 'You have already shown interest in this project.', 'error');
      console.error('Error submitting message:', error);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const filteredData = data
    .filter((row) =>
      (row.title || '').toLowerCase().includes(searchTerm)
    )
    .filter((row) =>
      categoryFilter ? row.projectType === categoryFilter : true
    );

  const paginatedData = filteredData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  return (
    <Box sx={{ p: 4, background: 'linear-gradient(135deg, #E8F5E9, #E3F2FD)', minHeight: '100vh' }}>
      <Card elevation={3} sx={{ mb: 3, borderRadius: 4, backgroundColor: '#FAFAFA', color: '#000', mt: 8 }}>
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2C3E50' }}>Submitted Projects</Typography>}
          subheader="View projects are Submitted by Entrepreneur"
          sx={{ py: 2, borderBottom: '1px solid #E0E0E0' }}
        />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Button
                variant={activeToggle === 'Group' ? 'contained' : 'outlined'}
                onClick={() => setActiveToggle('Group')}
                startIcon={<GroupIcon />}
                sx={{
                  mr: 1,
                  backgroundColor: activeToggle === 'Group' ? '#424242' : 'transparent',
                  color: activeToggle === 'Group' ? '#fff' : '#2C3E50',
                  '&:hover': { backgroundColor: '#616161' },
                }}
              >
                Group
              </Button>
              <Button
                variant={activeToggle === 'Single' ? 'contained' : 'outlined'}
                onClick={() => setActiveToggle('Single')}
                startIcon={<PersonIcon />}
                sx={{
                  backgroundColor: activeToggle === 'Single' ? '#424242' : 'transparent',
                  color: activeToggle === 'Single' ? '#fff' : '#2C3E50',
                  '&:hover': { backgroundColor: '#616161' },
                }}
              >
                Single
              </Button>
            </Box>

            <TextField
              placeholder="Search by Project Title"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: '#2C3E50' }} />,
              }}
              sx={{ width: '300px', backgroundColor: '#F5F5F5', borderRadius: 2, mr: 2 }}
            />

            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={categoryFilter}
                onChange={(e) => setCategoryFilter(e.target.value)}
              >
                <MenuItem value="">All Categories</MenuItem>
                <MenuItem value="AI/ML">AI/ML</MenuItem>
                <MenuItem value="Technology">Technology</MenuItem>
                <MenuItem value="Real Estate">Real Estate</MenuItem>
                <MenuItem value="Healthcare and Biotech">Healthcare and Biotech</MenuItem>
                <MenuItem value="Pharmacy ">Pharmacy </MenuItem>
                <MenuItem value="E-commerce and Retail">E-commerce and Retail</MenuItem>
                <MenuItem value="Education">Education</MenuItem>
                <MenuItem value="Finance and FinTech">Finance and FinTech</MenuItem>
                <MenuItem value="Energy and Sustainability">Energy and Sustainability</MenuItem>
                <MenuItem value="Entertainment and Media">Entertainment and Media</MenuItem>
                <MenuItem value="Agriculture and Food">Agriculture and Food</MenuItem>
                <MenuItem value="Fashion and Lifestyle">Fashion and Lifestyle</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </CardContent>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#B0BEC5' }}>
                <StyledTableCell>Sr. No.</StyledTableCell>
                <StyledTableCell>Project Title</StyledTableCell>
                <StyledTableCell>Project Type</StyledTableCell>
                <StyledTableCell>Project Pdf</StyledTableCell>
                <StyledTableCell>PPT</StyledTableCell>
                <StyledTableCell>Video File</StyledTableCell>
                
                <StyledTableCell>AI Score</StyledTableCell>
                <StyledTableCell>Action</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow key={row.id}>
                  <StyledTableCell>{(page - 1) * ITEMS_PER_PAGE + index + 1}</StyledTableCell>
                  <StyledTableCell>{row.title}</StyledTableCell>
                  <StyledTableCell>{row.projectType}</StyledTableCell>
                  <StyledTableCell>
                    {row.idea ? (
                      <IconButton
                        size="small"
                        href={row.idea}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.ppt ? (
                      <IconButton
                        size="small"
                        href={row.ppt}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                  <StyledTableCell>
                    {row.video_file ? (
                      <IconButton
                        size="small"
                        href={row.video_file}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CloudDownloadIcon sx={{ color: '#424242' }} />
                      </IconButton>
                    ) : (
                      'No file'
                    )}
                  </StyledTableCell>
                  <StyledTableCell>{row.aiScore}</StyledTableCell>
                  <StyledTableCell>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: '#424242',
                        color: '#fff',
                        '&:hover': { backgroundColor: '#616161' },
                      }}
                      onClick={() => openMessageDialog(row.id)}
                    >
                      Show Interest
                    </Button>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          count={Math.ceil(filteredData.length / ITEMS_PER_PAGE)}
          page={page}
          onChange={handleChangePage}
          sx={{ mt: 3 }}
        />
      </Card>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Send Message</DialogTitle>
        <DialogContent>
          <DialogContentText>Enter your message and amount range:</DialogContentText>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Message"
            sx={{ mt: 1 }}
          />
          <TextField
            fullWidth
            value={amountRange}
            onChange={(e) => setAmountRange(e.target.value)}
            placeholder="Amount Range"
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleSubmitMessage}>Submit</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Cancelled;